module.exports = __webpack_public_path__ + "img/info_08.84a07b7a.png";